module.exports = __webpack_public_path__ + "static/media/garden_bowl.5313acbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/garden_bowl.jpg
// module id = 158
// module chunks = 0